import React from "react";
import { Box, Button, Flex, Icon, Text, Tooltip } from "@chakra-ui/react";
import { MdInfoOutline } from "react-icons/md";
import { observer } from "mobx-react-lite";
import { helperInfo } from "@uidaholib/shared/models/ui/ui";

const HelperButton = observer(({ id, show = false }) => {
  const toggleInfo = () => {
    helperInfo.toggle();
  };
  return (
    <Box id={id} bg="transparent" borderRadius="lg">
      {show && (
        <Tooltip label="Show help" hasArrow>
          <Button
            zIndex={70}
            bg={helperInfo.isOpen ? "green.400" : "white"}
            color={helperInfo.isOpen ? "white" : "gray.600"}
            _hover={{bg: "green.400", color: "white"}}
            fontWeight="semibold"
            borderRadius="lg"
            boxShadow="lg"
            py={2}
            px={4}
            onClick={toggleInfo}
          >
            <Flex alignItems="center">
              <Icon boxSize={6} as={MdInfoOutline} mr={2} />
              <Text>Help</Text>
            </Flex>
          </Button>
        </Tooltip>
      )}
    </Box>
  );
});

export default HelperButton;
